/* eslint-disable react-refresh/only-export-components */
import AdicionarCertificado from '@/templates/Admin/Certificados/modals/Adicionar'
import ExcluirCertificado from '@/templates/Admin/Certificados/modals/Excluir'
import AdicionarPlano from '@/templates/Admin/PlanosPrecos/modals/Adicionar'
import EditarPlano from '@/templates/Admin/PlanosPrecos/modals/Editar'
import ExcluirPlano from '@/templates/Admin/PlanosPrecos/modals/Excluir'
import ImportarPlano from '@/templates/Admin/PlanosPrecos/modals/Importar'
import React from 'react'
import {
    Outlet,
    RouteObject,
    useOutletContext,
    useSearchParams,
} from 'react-router-dom'
import { Cliente, clientes as clientesApi } from 'service/api'
import { PaginatedResponse } from 'service/api/types'
import AdminAlterarSenha from 'templates/Admin/Clientes/atoms/AlterarSenha'
import AdicionarClientes from 'templates/Admin/Clientes/modals/Adicionar'
import { DetalhesRegistro } from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesRegistros'
import EditarCliente from 'templates/Admin/Clientes/modals/Editar'
import FinanceiroCliente from 'templates/Admin/Clientes/modals/Financeiro'
import AdicionarTreinamento from 'templates/Admin/Clientes/modals/Treinamentos/Adicionar'
import EditarTreinamento from 'templates/Admin/Clientes/modals/Treinamentos/Editar'
import ExcluirTreinamento from 'templates/Admin/Clientes/modals/Treinamentos/Excluir'
import AdicionarUsuario from 'templates/Admin/Usuarios/modals/Adicionar'
import EditarUsuario from 'templates/Admin/Usuarios/modals/Editar'
import DetalhesEmpresa from 'templates/Cadastro/Empresas/modals/Detalhes'
import DetalhesFuncionario from 'templates/Cadastro/Funcionarios/organismos/modals/Detalhes'

const Clientes = React.lazy(() => import('pages/Clientes'))
const UsuariosPage = React.lazy(() => import('pages/Usuarios'))
const Certificados = React.lazy(() => import('pages/Certificados'))
const ParametrosFinanceiros = React.lazy(
    () => import('@/pages/ReajustesAnuais'),
)
const EmpresasClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Empresas'),
)

const RegistrosEmpresaCliente = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/RegsitrosEmpresas'),
)

const UsuariosClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Usuarios'),
)

const ModulosClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Modulo'),
)

const CobrancasClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Cobrancas'),
)

const CredenciaisApiClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/CredenciaisApi'),
)

const EditarCredencialApiCliente = React.lazy(
    () => import('@/templates/Admin/Clientes/modals/EditarCredencialApi'),
)

const TrocasInicioPontoEmpresa = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/TrocaInicioPonto'),
)
const AdicionarTrocaInicioPonto = React.lazy(
    () =>
        import(
            '@/templates/Admin/Clientes/atoms/Pages/AdicionarTrocaInicioPonto'
        ),
)
const FuncionariosEmpresaCliente = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/FuncionariosEmpresas'),
)
const PlanosPrecos = React.lazy(() => import('pages/PlanosPrecos'))

const base = '/administracao'
const clientes = '/clientes'
const certificados = '/certificados'
const clienteId = '/clientes/:id'
const empresas = '/empresas'
const usuarios = '/usuarios'
const empresaId = '/empresas/:empresaId'
const registros = '/registros'
const registroIdDetalhes = '/registros/:registroId/detalhes'
const funcionarios = '/funcionarios'
const funcionarioIdDetalhes = '/funcionarios/:funcionarioId/detalhes'
const clienteIdCobrancas = '/clientes/:clienteId/cobrancas'
const integracaoApi = '/integracao-api'

const AdminPreloader = () => {
    const [searchParams] = useSearchParams()
    const filter = searchParams.get('filter')

    const { data } = clientesApi.useFetch<PaginatedResponse<Cliente>>({
        queryParams: filter ? { filter } : undefined,
        enabled: true,
    })

    return <Outlet context={{ clientes: data?.data }} />
}

export function useAdminOutletContext() {
    return useOutletContext<{ clientes?: Cliente[] }>()
}

export const admin: RouteObject = {
    path: base,
    element: <AdminPreloader />,
    children: [
        {
            // url: /administracao/clientes
            path: base + clientes,
            element: <Clientes />,
            children: [
                {
                    path: base + clientes + '/adicionar',
                    element: <AdicionarClientes />,
                },
                {
                    path: base + clienteId + '/editar',
                    element: <EditarCliente />,
                },
                {
                    path: base + clienteId + '/financeiro',
                    element: <FinanceiroCliente />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/usuarios
            path: base + clienteId + usuarios,
            element: <UsuariosClientePage />,
            children: [
                {
                    path: base + clienteId + usuarios + '/:id/alterar-senha',
                    element: <AdminAlterarSenha />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/modulos
            path: base + clienteId + '/modulos',
            element: <ModulosClientePage />,
        },
        {
            // url: /administracao/clientes/:id/integracao-api
            path: base + clienteId + integracaoApi,
            element: <CredenciaisApiClientePage />,
            children: [
                {
                    path:
                        base +
                        clienteId +
                        integracaoApi +
                        '/:credencialId/editar',
                    element: <EditarCredencialApiCliente />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/cobrancas
            path: base + clienteIdCobrancas,
            element: <CobrancasClientePage />,
            children: [
                {
                    path: base + clienteIdCobrancas + '/adicionar',
                    element: <AdicionarTreinamento />,
                },
                {
                    path: base + clienteIdCobrancas + '/:id/editar',
                    element: <EditarTreinamento />,
                },
                {
                    path: base + clienteIdCobrancas + '/:id/excluir',
                    element: <ExcluirTreinamento />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/empresas
            path: base + clienteId + empresas,
            element: <EmpresasClientePage />,
            children: [
                {
                    path: base + clienteId + empresaId + '/detalhes',
                    element: <DetalhesEmpresa />,
                },
            ],
        },
        {
            path: base + clienteId + empresaId + '/troca-inicio-ponto',
            element: <TrocasInicioPontoEmpresa />,
            children: [
                {
                    path:
                        base +
                        clienteId +
                        empresaId +
                        '/troca-inicio-ponto/adicionar',
                    element: <AdicionarTrocaInicioPonto />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/empresas/:empresaId/registros
            path: base + clienteId + empresaId + registros,
            element: <RegistrosEmpresaCliente />,
            children: [
                {
                    path: base + clienteId + empresaId + registroIdDetalhes,
                    element: <DetalhesRegistro />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/empresas/:empresaId/funcionarios
            path: base + clienteId + empresaId + funcionarios,
            element: <FuncionariosEmpresaCliente />,
            children: [
                {
                    path: base + clienteId + empresaId + funcionarioIdDetalhes,
                    element: <DetalhesFuncionario />,
                },
            ],
        },
        {
            // url: /administracao/usuarios
            path: base + usuarios,
            element: <UsuariosPage />,
            children: [
                {
                    path: base + usuarios + '/adicionar',
                    element: <AdicionarUsuario />,
                },
                {
                    path: base + usuarios + '/:id/editar',
                    element: <EditarUsuario />,
                },
            ],
        },
        {
            // url: /administracao/certificados
            path: base + certificados,
            element: <Certificados />,
            children: [
                {
                    path: base + certificados + '/adicionar',
                    element: <AdicionarCertificado />,
                },
                {
                    path: base + certificados + '/:id/excluir',
                    element: <ExcluirCertificado />,
                },
            ],
        },
        {
            path: base + '/planos-precos',
            element: <PlanosPrecos />,
            children: [
                {
                    path: base + '/planos-precos/adicionar',
                    element: <AdicionarPlano />,
                },
                {
                    path: base + '/planos-precos/:planoId/editar',
                    element: <EditarPlano />,
                },
                {
                    path: base + '/planos-precos/:planoId/excluir',
                    element: <ExcluirPlano />,
                },
                {
                    path: base + '/planos-precos/importar',
                    element: <ImportarPlano />,
                },
            ],
        },
    ],
}
